import { Fragment } from 'react';
import { IconButton, useEventCallback } from '@mui/material';
import { createSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ActionProps } from 'shell/view-models/actions-props';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { __PERSON_NEW_API_URL__ } from 'shell/constants/environment';
import { Visibility } from '@mui/icons-material';

const ActionsList = ({ cell, filterPersonForm }: ActionProps): React.ReactElement => {
  const navigate = useNavigate();

  const getPerson = useHttpClient(`${__PERSON_NEW_API_URL__}/ricerca-persona/ristampa-carta`, {
    options: {
      loading: true,
      errorCatching: true,
      method: 'POST',
    },
  });

  const onVisibilityPress = useEventCallback(() => {
    return new Promise((resolve) => {
      (
        getPerson({
          data: {
            criteriRicerca: {
              idSchedaSoggettoANPR: cell?.anpr,
              codiceFiscale: cell?.fiscalCode || undefined,
            },
            datiRichiesta: {
              ricercaNazionale:
                filterPersonForm?.subjectData?.isNationalResearch ||
                filterPersonForm?.commonSearch?.isNationalResearch
                  ? '1'
                  : '0',
            },
          },
        }) as ResponsePromise<void>
      ).then(() => {
        navigate({
          pathname: '/sportello/ristampa-carta/ricerca-persona/ristampa',
          search: `?${createSearchParams({
            codiceFiscale: cell?.fiscalCode || '',
            idSchedaSoggettoANPR: cell?.anpr || '',
            ricercaNazionale:
              filterPersonForm?.commonSearch?.isNationalResearch?.toString() ||
              filterPersonForm?.subjectData?.isNationalResearch?.toString() ||
              'false',
          })}`,
        });
        resolve(cell);
      });
    });
  });

  return (
    <Fragment>
      <IconButton
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onVisibilityPress();
        }}
        aria-label="Visualizza elemento"
        aria-haspopup="true"
        style={{
          padding: '4px',
        }}
      >
        <Visibility />
      </IconButton>
    </Fragment>
  );
};

ActionsList.displayName = 'Action list Document - residency permit page component';

export default ActionsList;
